import axios from 'axios';
import buildQuery from 'odata-query';

import toast from 'components/Toast/dispatch';
import Services from './index.service';

import { IUser } from 'models/User';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { DeParaReportProps, DownloadRaReportsProps, DownloadReportsProps, SentItemsReportProps } from 'models/Report';
import successImg from "img/success-img.svg";

export default class ReportService extends Services<any, any> {
  public async DownloadReportUser(url: string, filter: {}) {
    const skip = 0;
    const top = 99999999;
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<IUser> = {
      url: `/users/${url}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $filter: filterQuery.split('=')[1] || undefined,
      },
      timeout: 600000 // 10 minutos
    };

    return await this.httpRequest(config)
      .then(result => {
        result.data ?
          ReportService.CreateDownloadLink(result.data.fileUrl) :
          toast.error('Desculpe, erro inesperado!');
      })
      .catch(() => toast.error('Desculpe, erro inesperado!'));
  }

  public async DownloadReportLegalDocuments() {
    const config = {
      url: `${this.base_url}/customer/legal-documents-excel`,
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await this.ReturnAxios(config);
  }

  public async DownloadQualifications(sentObj: DownloadReportsProps) {
    const config = {
      url: `${this.base_url}/ratings/export-rating-excel`,
      params: {
        startPeriod: sentObj.startPeriod,
        lastPeriod: sentObj.lastPeriod
      },
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await this.ReturnAxios(config);
  }

  public async DownloadNpsPhysicalStores(sentObj: DownloadReportsProps) {
    const config = {
      url: `${this.base_url}/store/export-store-answer-excel`,
      params: {
        startPeriod: sentObj.startPeriod,
        lastPeriod: sentObj.lastPeriod
      },
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await this.ReturnAxios(config);
  }

  private async ReturnAxios(config: any) {

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );

    return axios(config)
      .then(result => {
        if (result.status !== 200 && result.data?.data) {
          toast.error(result.data.data);
        }
        else if (result.data?.data?.fileUrl) {
          return ReportService.CreateDownloadLink(result.data.data.fileUrl);
        }
        else {
          return toast.error('Desculpe, erro inesperado!');
        }
      })
      .catch(() => toast.error('Desculpe, erro inesperado!'));
  }


  private async ReturnRaAxios(config: any) {

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );

    return axios(config)
      .then(result => {
        if (result.status == 200) {
          toast.info('Seus dados estão sendo processados','Estamos coletando os dados solicitados.\nVocê receberá um e-mail assim\nque o relatório estiver finalizado.', successImg,);
        }
        else if (result.data?.data?.fileUrl) {
          return ReportService.CreateDownloadLink(result.data.data.fileUrl);
        }
        else {
          return toast.error('Desculpe, erro inesperado!');
        }
      })
      .catch(() => toast.error('Desculpe, erro inesperado!'));
  }

  public static CreateDownloadLink = (path: string | undefined) => {
    if (path) {
      const link = document.createElement('a');
      link.href = path;
      link.click();
    }
  };

  public async DownloadPortalReport(sentObj: DownloadRaReportsProps) {
    const config = {
      url: `${this.mafraq_url}/Report/download`,
      params: {
        startDate: sentObj.startDate,
        endDate: sentObj.endDate,
        type: sentObj.type
      },
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await this.ReturnRaAxios(config);
  }

  public async DownloadSentItemsReport(sentObj: SentItemsReportProps) {
    const config = {
      url: `${this.mafraq_url}/report/itens-enviados`,
      data: {
        startDate: sentObj.startDate,
        endDate: sentObj.endDate,
        type: sentObj.type,
        searchType: sentObj.searchType ?? null,
        terms: sentObj.terms ?? [],
      },
      method: MethodsTypes.post,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await axios(config).catch(() => undefined);
  }

  public async DownloadDeParaReport(sentObj: DeParaReportProps) {
    const config = {
      url: `${this.mafraq_url}/Report/depara`,
      data: {
        startDate: sentObj.startDate,
        endDate: sentObj.endDate,
        type: sentObj.type,
        searchType: sentObj.searchType ?? null,
        terms: sentObj.terms ?? [],
      },
      method: MethodsTypes.post,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    await axios(config).catch(() => undefined);
  }
}
